export default __webpack_public_path__ + "a3f8b4b78ef15c650ea8574f29588f74.svg";